import { isSet } from '../util/isSet';

export const PADDING_ALL = {
	0: 'p-0',
	auto: 'p-auto',
	xxs: 'p-xxs',
	xs: 'p-xs',
	sm: 'p-sm',
	md: 'p-md',
	lg: 'p-lg',
	xl: 'p-xl',
	xxl: 'p-xxl',
	xxxl: 'p-xxxl',
} as const;
export type PaddingAll = keyof typeof PADDING_ALL;
export type PaddingAllValues = typeof PADDING_ALL[PaddingAll];

export const PADDING_ALL_TABLET = {
	0: 'tablet:p-0',
	auto: 'tablet:p-auto',
	xxs: 'tablet:p-xxs',
	xs: 'tablet:p-xs',
	sm: 'tablet:p-sm',
	md: 'tablet:p-md',
	lg: 'tablet:p-lg',
	xl: 'tablet:p-xl',
	xxl: 'tablet:p-xxl',
	xxxl: 'tablet:p-xxxl',
} as const;
export type PaddingAllTablet = keyof typeof PADDING_ALL_TABLET;
export type PaddingAllTabletValues = typeof PADDING_ALL_TABLET[PaddingAllTablet];


export const PADDING_ALL_DESKTOP = {
	0: 'desktop:p-0',
	auto: 'desktop:p-auto',
	xxs: 'desktop:p-xxs',
	xs: 'desktop:p-xs',
	sm: 'desktop:p-sm',
	md: 'desktop:p-md',
	lg: 'desktop:p-lg',
	xl: 'desktop:p-xl',
	xxl: 'desktop:p-xxl',
	xxxl: 'desktop:p-xxxl',
} as const;
export type PaddingAllDesktop = keyof typeof PADDING_ALL_DESKTOP;
export type PaddingAllDesktopValues = typeof PADDING_ALL_DESKTOP[PaddingAllDesktop];


export const PADDING_BLOCK = {
	0: 'py-0',
	auto: 'py-auto',
	xxs: 'py-xxs',
	xs: 'py-xs',
	sm: 'py-sm',
	md: 'py-md',
	lg: 'py-lg',
	xl: 'py-xl',
	xxl: 'py-xxl',
	xxxl: 'py-xxxl',
} as const;
export type PaddingBlock = keyof typeof PADDING_BLOCK;
export type PaddingBlockValues = typeof PADDING_BLOCK[PaddingBlock];


export const PADDING_BLOCK_TABLET = {
	0: 'tablet:py-0',
	auto: 'tablet:py-auto',
	xxs: 'tablet:py-xxs',
	xs: 'tablet:py-xs',
	sm: 'tablet:py-sm',
	md: 'tablet:py-md',
	lg: 'tablet:py-lg',
	xl: 'tablet:py-xl',
	xxl: 'tablet:py-xxl',
	xxxl: 'tablet:py-xxxl',
} as const;
export type PaddingBlockTablet = keyof typeof PADDING_BLOCK_TABLET;
export type PaddingBlockTabletValues = typeof PADDING_BLOCK_TABLET[PaddingBlockTablet];


export const PADDING_BLOCK_DESKTOP = {
	0: 'desktop:py-0',
	auto: 'desktop:py-auto',
	xxs: 'desktop:py-xxs',
	xs: 'desktop:py-xs',
	sm: 'desktop:py-sm',
	md: 'desktop:py-md',
	lg: 'desktop:py-lg',
	xl: 'desktop:py-xl',
	xxl: 'desktop:py-xxl',
	xxxl: 'desktop:py-xxxl',
} as const;
export type PaddingBlockDesktop = keyof typeof PADDING_BLOCK_DESKTOP;
export type PaddingBlockDesktopValues = typeof PADDING_BLOCK_DESKTOP[PaddingBlockDesktop];


export const PADDING_INLINE = {
	0: 'px-0',
	auto: 'px-auto',
	xxs: 'px-xxs',
	xs: 'px-xs',
	sm: 'px-sm',
	md: 'px-md',
	lg: 'px-lg',
	xl: 'px-xl',
	xxl: 'px-xxl',
	xxxl: 'px-xxxl',
} as const;
export type PaddingInline = keyof typeof PADDING_INLINE;
export type PaddingInlineValues = typeof PADDING_INLINE[PaddingInline];


export const PADDING_LEFT = {
	0: 'pl-0',
	auto: 'pl-auto',
	xxs: 'pl-xxs',
	xs: 'pl-xs',
	sm: 'pl-sm',
	md: 'pl-md',
	lg: 'pl-lg',
	xl: 'pl-xl',
	xxl: 'pl-xxl',
	xxxl: 'pl-xxxl',
} as const;
export type PaddingLeft = keyof typeof PADDING_LEFT;
export type PaddingLeftValues = typeof PADDING_LEFT[PaddingLeft];

export const PADDING_BOTTOM = {
	0: 'pb-0',
	auto: 'pb-auto',
	xxs: 'pb-xxs',
	xs: 'pb-xs',
	sm: 'pb-sm',
	md: 'pb-md',
	lg: 'pb-lg',
	xl: 'pb-xl',
	xxl: 'pb-xxl',
	xxxl: 'pb-xxxl',
} as const;
export type PaddingBottom = keyof typeof PADDING_BOTTOM;
export type PaddingBottomValues = typeof PADDING_BOTTOM[PaddingBottom];

export const PADDING_BOTTOM_TABLET = {
	0: 'tablet:pb-0',
	auto: 'tablet:pb-auto',
	xxs: 'tablet:pb-xxs',
	xs: 'tablet:pb-xs',
	sm: 'tablet:pb-sm',
	md: 'tablet:pb-md',
	lg: 'tablet:pb-lg',
	xl: 'tablet:pb-xl',
	xxl: 'tablet:pb-xxl',
	xxxl: 'tablet:pb-xxxl',
} as const;
export type PaddingBottomTablet = keyof typeof PADDING_BOTTOM_TABLET;
export type PaddingBottomTabletValues = typeof PADDING_BOTTOM_TABLET[PaddingBottomTablet];

export const PADDING = {
	all: PADDING_ALL,
	block: PADDING_BLOCK,
	inline: PADDING_INLINE,
	bottom: PADDING_BOTTOM,
	left: PADDING_LEFT,
} as const;

export interface PaddingProp {
	all?: PaddingAll;
	block?: PaddingBlock;
	inline?: PaddingInline;
	left?: PaddingLeft;
	// right?:
	// top?:
	bottom?: PaddingBottom;
}


export const PADDING_TABLET = {
	all: PADDING_ALL_TABLET,
	block: PADDING_BLOCK_TABLET,
	bottom: PADDING_BOTTOM_TABLET,
} as const;

export interface PaddingTabletProp {
	all?: PaddingAllTablet;
	block?: PaddingBlockTablet;
	// inline?: PaddingInlineTablet;
	// left?:
	// right?:
	// top?:
	bottom?: PaddingBottomTablet;
}


export const PADDING_DESKTOP = {
	all: PADDING_ALL_DESKTOP,
	block: PADDING_BLOCK_DESKTOP,
} as const;

export interface PaddingDesktopProp {
	all?: PaddingAllDesktop;
	block?: PaddingBlockDesktop;
	// inline?: PaddingInlineDesktop;
	// left?:
	// right?:
	// top?:
	// bottom?:
}

export const paddingCn = (props?: PaddingProp): null
	| (
		PaddingAllValues
		| PaddingBlockValues
		| PaddingInlineValues
		| PaddingBottomValues
		| PaddingLeftValues
		| null
	)[] => {
	if (!props) { return null; }
	const {
		all,
		block,
		inline,
		bottom,
		left,
	} = props;
	return [
		isSet(all) ? PADDING_ALL[all] : null,
		isSet(block) ? PADDING_BLOCK[block] : null,
		isSet(inline) ? PADDING_INLINE[inline] : null,
		isSet(bottom) ? PADDING_BOTTOM[bottom] : null,
		isSet(left) ? PADDING_LEFT[left] : null,
	];
};

export const paddingTabletCn = (props?: PaddingTabletProp): null
	| (
		PaddingAllTabletValues
		| PaddingBlockTabletValues
		| PaddingBottomTabletValues
		| null
	)[] => {
	if (!props) { return null; }
	const {
		all,
		block,
		// inline,
		// left,
		bottom,
	} = props;
	return [
		isSet(all) ? PADDING_ALL_TABLET[all] : null,
		isSet(block) ? PADDING_BLOCK_TABLET[block] : null,
		isSet(bottom) ? PADDING_BOTTOM_TABLET[bottom] : null,
		// isSet(inline) ? PADDING_INLINE_TABLET[inline] : null,
	];
};

export const paddingDesktopCn = (props?: PaddingDesktopProp): null
	| (
		PaddingAllDesktopValues
		| PaddingBlockDesktopValues
		| null
	)[] => {
	if (!props) { return null; }
	const {
		all,
		block,
		// inline,
		// left
	} = props;
	return [
		isSet(all) ? PADDING_ALL_DESKTOP[all] : null,
		isSet(block) ? PADDING_BLOCK_DESKTOP[block] : null,
		// isSet(inline) ? PADDING_INLINE_DESKTOP[inline] : null,
	];
};
